// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WiN0bmrfoJkBhqD93WdO{flex:1;height:100%;display:flex;overflow:auto}.DKU1ML8l40RvgWGT8KFA{background-color:var(--background-primary-inverted-primary);width:100%;min-width:0;height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `WiN0bmrfoJkBhqD93WdO`,
	"content": `DKU1ML8l40RvgWGT8KFA`
};
export default ___CSS_LOADER_EXPORT___;
